
import {
    MDBAlert,
    MDBBadge,
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCardHeader,
    MDBCardTitle,
    MDBCol,
    MDBContainer,
    MDBIcon,
    MDBLightbox,
    MDBLightboxItem,
    MDBRow,
    MDBSpinner,MDBScrollbar,
    MDBTooltip
} from 'mdb-react-ui-kit';
import { Link, useNavigate, useParams } from 'react-router-dom';

import React, { useContext, useEffect, useState } from 'react';
import { fetchCompanyMap, fetchDocumentMap } from '../utils/Common';
import MultiViewModal from './MultiViewModal';
import { UserProfileContext } from '../context/UserProfileProvider';
import { MiscContext } from '../context/MiscProvider';
const Processed = () => {
    const { companiesMap,documentsMap ,setCompaniesMap, setDocumentsMap} = useContext(MiscContext);
    const {tokenLoaded} = useContext(UserProfileContext);
    const [isReceiptToBeViewed, setIsReceiptToBeViewed] = useState(false);
    const [companyName, setCompanyName] = useState(null);
    const [sortedCompanies,setSortedCompanies] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const {type} = useParams();
    const calculateTotalCount = (documents) => {
        let totalCount = 0;
        Object.values(documents).forEach(companies => {
            totalCount += companies.length; // Assuming companies is an array of documents
        });
        return totalCount;
    };
    
   

    useEffect(() => {
        const fetchDocData = async () => {
          if (tokenLoaded ) { // Assume isDocumentsFetched tracks if fetching is needed
            await fetchDocumentMap(setDocumentsMap,tokenLoaded);
           
          }
        };
      
        fetchDocData();
      }, [setDocumentsMap, tokenLoaded]); // Only re-run when tokenLoaded changes
      
    
      useEffect(() => {
        const fetchCompData = async () => {
          if (tokenLoaded ) { // Assume isDocumentsFetched tracks if fetching is needed
            await fetchCompanyMap(setCompaniesMap,tokenLoaded);
            // State to prevent re-fetching
          }
        };
      
        fetchCompData();
      }, [setCompaniesMap, tokenLoaded]); // Only re-run when tokenLoaded changes
      
    

    useEffect(() => {
        
        let filteredCompanies = [];
        let newCounts;
     if (type === 'other') {
    filteredCompanies = Array.isArray(companiesMap) && companiesMap.filter(company => {
        return company.receipts?.some(receipt => receipt.type === 'other');

        
    });
//if(filteredCompanies.length === 0) {
    

// if (documentsMap && documentsMap.othersProcessed) {
//     Object.values(documentsMap.othersProcessed).forEach(companies => {
//         // Iterate over each company
//         companies.forEach(company => {
//             // Check if the company has receipts and it's an array
//             if (Array.isArray(company.receipts)) {
//                 // Push each receipt into the filteredCompanies array
//                 company.receipts.forEach(receipt => {
//                     filteredCompanies.push(receipt);
//                 });
//             }
//         });
//     });
// }




// if (documentsMap?.othersProcessed) {
//     Object.keys(documentsMap.othersProcessed).forEach(companyKey => {
//         const company = documentsMap.othersProcessed[companyKey];
//         company.forEach(receipt => {
//             filteredCompanies.push({
//                 companyName: companyKey,
//                 ...receipt
//             });
//         });
//     });
// }

// console.log(filteredCompanies);  // This will now contain all receipts, with each receipt having its company name added to it.


// } 
    newCounts = calculateTotalCount(documentsMap?.othersProcessed || {}); // Assuming receiptsUnProcessed holds your data
} else if (type === 'receipt') {
    filteredCompanies = Array.isArray(companiesMap) && companiesMap.filter(company => {
        return company.receipts?.some(receipt => receipt.type === 'receipt');
    });
    newCounts = calculateTotalCount(documentsMap?.receiptsProcessed || {}); // Assuming receiptsUnProcessed holds your data
}
       setSortedCompanies(filteredCompanies);
    
        // Check if sortedCompanies is not empty
        if (filteredCompanies.length === 0) {
            //navigate('/unProcessed');        
            setIsLoading(false);
        }
        setTotalCount(newCounts);// State to prevent re-fetching
    }, [companiesMap, companiesMap.length, documentsMap.length, tokenLoaded, type]); // Add sortedCompanies and type as dependencies to trigger the effect when they change
    

    return (
        <MDBContainer className="mb-2 position-relative grainy-gradient-intro justify-content-center text-center">
             <div className="d-flex align-items-center justify-content-center mt-3">
         {isLoading &&
                <MDBSpinner className='mx-2 justify-content-center' color='warning'>
                    <span className='visually-hidden '>Loading...</span>
                </MDBSpinner>}
                </div>

            {isReceiptToBeViewed && <MultiViewModal isReceiptToBeViewed={isReceiptToBeViewed} setIsReceiptToBeViewed={setIsReceiptToBeViewed} companyName={companyName} setShowAlert={setShowAlert}/>}
            <MDBCard className='text-center'>
    <MDBCardBody className='justify-content-center'>
        <MDBCard className="border" md='12'>
          <MDBCardHeader> { sortedCompanies?.length>0 && <MDBCardTitle className='text-black text-capitalize'>Processed, {type} Documents </MDBCardTitle> }
            <div className="d-flex align-items-center justify-content-center">
     <MDBAlert  open={showAlert} className='w-50 text-center' color='success' autohide
        delay={5000}
       
        onClose={() => {setShowAlert(false); setIsLoading(false)}}>
     <i className="fas fa-check-circle me-3"><h6 className='alert-heading'>Removed from Processed List</h6></i> 
     <MDBBtn color='link' onClick={()=> setShowAlert(false)}>close</MDBBtn>
    </MDBAlert>
    </div>
             {sortedCompanies?.length>0 &&<>
                 
              <MDBBtn color='primary' href='#' className='text-light'>
                    <Link to={`/unProcessed/${type}`} style={{color:'white'}}>Go To UnProcessed</Link>
                </MDBBtn> 
                <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#55acee' }}>
                  <Link to={`/no-receipts/receipt`}><MDBIcon fas icon="cloud-upload-alt" /></Link>
              </MDBBtn>
              </> 
             
                }
              
            </MDBCardHeader>
            <MDBCardBody>

                {sortedCompanies?.length>0 ? 
                <MDBRow className="row-cols-1 row-cols-md-1 justify-content-center"> {/* Set the number of columns for different screen sizes */}
                    {sortedCompanies?.map((company, index) => (
                        <MDBCol key={index} className="mb-3"> {/* Set margin bottom */}
                            <MDBCard>
                                <MDBCardBody>
                                    <h5 className="card-title text-black text-capitalize">{company.name}</h5> 
                                    <MDBScrollbar style={{ position: 'relative', height: 'auto', whiteSpace: 'nowrap' }}>
      {Array.isArray(company.receipts) && company.receipts.length > 0 && company.receipts.map((receipt, index) => (
        <div key={index} style={{ display: 'inline-block', marginRight: '10px' }}>
          <MDBTooltip wrapperProps={{ color: 'black' }} title="Click To view receipt">
            <MDBLightbox className="d-flex align-items-center justify-content-center">
              <MDBLightboxItem
                style={{ width: '200px'}}
                zoomLevel={0.25}
                src={receipt.receiptUrl}
                fullscreenSrc={receipt.receiptUrl}
              />
            </MDBLightbox>
          </MDBTooltip>
        </div>
      ))}
    </MDBScrollbar>

                                    <MDBBtn size='sm' tag='a' color='none' className='m-1' style={{ color: '#dd4b39' }} onClick={() => {
                                        setIsReceiptToBeViewed(true);
                                        setCompanyName(company.name);
                                    }}>
                                        <MDBTooltip tag='a' wrapperProps={{ href: '#' }} title=" detailed view..." >
                                            <span className='text-black'>view</span>
                                        </MDBTooltip>
                                    </MDBBtn>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    ))}
                </MDBRow> :
                 <div className='p-5 text-center bg-light'>
                 <h1 className='mb-3 text-capitalize'>No Processed Document of Type {type}</h1>
                 {/* <h6 className='mb-3'>Please Go To UnProcessed of Type {type}</h6> */}
                 <MDBBtn color='black' href='#'>
                    <Link to={`/unProcessed/${type}`}>Go To UnProcessed</Link>
                </MDBBtn>
                <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#55acee' }}>
            <Link to={`/no-receipts/receipt`}><MDBIcon fas icon="cloud-upload-alt" /></Link>
        </MDBBtn>
               </div>
}
            </MDBCardBody>
        </MDBCard>

        <span style={{ position: 'absolute', top: 35, right: 25 }}>
                  <MDBBadge color='black' dark  className='position-absolute translate-middle'>
                        {totalCount}
                      </MDBBadge>
                      </span>
    </MDBCardBody>
</MDBCard>


        </MDBContainer>
    );

}


export default Processed;